"use strict";

function StatusBanner() {
  const STATUS_CLASSES = ["success-banner", "info-banner", "warning-banner"];
  const FORCE_SHOW_PRIORITY = 5;

  const messageQueue = [];
  let pendingTimeout = null;
  let $banner;

  function init() {
    if ($banner) {
      return;
    }

    $banner = $(".status-bar-container");
    _setupEventListeners();
  }

  function _setupEventListeners() {
    $banner.on("click", _expand);
    $banner.on("click", ".status-banner-expanded-back-button", _contract);
    $banner.on("click", ".status-banner-dismiss-button", dismiss);
  }

  function _expand() {
    $banner.addClass("banner-expanded");
    _cancelTimeout();
  }

  function _contract(e) {
    $banner.removeClass("banner-expanded");
    e?.stopPropagation(); // Prevent calling _expandStatusBanner()

    const currentMessage = messageQueue[0];
    if (currentMessage) {
      _updateTimeout(currentMessage.timeoutToClose);
    }
  }

  function _onMessageTimeout() {
    if (!_isExpanded()) {
      _nextInQueue();
    }
  }

  function _setStatusClass(displayStatus) {
    $banner.removeClass(STATUS_CLASSES.join(" "));
    $banner.addClass(`${displayStatus}-banner`);
  }

  function queueMessage({
    id = null,
    titleContracted,
    titleExpanded,
    contentsHtml,
    priority,
    displayStatus,
    buttonCallback,
    timeoutToClose = null,
    dismissable = false,
  }) {
    init();

    const message = _createMessage({
      id,
      titleContracted,
      titleExpanded,
      contentsHtml,
      priority,
      displayStatus,
      buttonCallback,
      timeoutToClose,
      dismissable,
    });

    if (_handleExistingMessage(message)) {
      return;
    }

    _addToQueue(message);
  }

  function _createMessage(messageData) {
    return {
      ...messageData,
      timestamp: Date.now(),
    };
  }

  function _handleExistingMessage(message) {
    if (!message.id) {
      return false;
    }

    const existingIndex = messageQueue.findIndex((msg) => msg.id === message.id);
    if (existingIndex === -1) {
      return false;
    }

    messageQueue[existingIndex] = {
      ...messageQueue[existingIndex],
      ...message,
    };

    if (existingIndex === 0) {
      _showMessage(messageQueue[existingIndex]);
    }

    return true;
  }

  function _showMessage(message) {
    _updateTimeout(message.timeoutToClose);
    _renderBannerContent(message);
    _toggleVisibility(true);

    if (message.priority >= FORCE_SHOW_PRIORITY && !message.hasBeenExpanded) {
      message.hasBeenExpanded = true;
      _expand();
    }
  }

  function _toggleVisibility(show) {
    $("body").toggleClass("status-banner-visible", show);
    MapFunctions.setMapHeight();
  }

  function _isExpanded() {
    return $banner.hasClass("banner-expanded");
  }

  function _isVisible() {
    return $("body").hasClass("status-banner-visible");
  }

  function _renderBannerContent(message) {
    _setStatusClass(message.displayStatus);

    const bannerHtml = nunjucks.render("statusBanner/bannerExpanded.njk", {
      titleContracted: message.titleContracted,
      titleExpanded: message.titleExpanded,
      contentsHtml: message.contentsHtml,
      dismissable: message.dismissable,
    });

    $banner.html(bannerHtml);
    $banner.off("click", ".status-banner-action-button");
    if (message.buttonCallback) {
      $banner.on("click", ".status-banner-action-button", message.buttonCallback);
    }
  }

  function _updateTimeout(timeoutDuration) {
    _cancelTimeout();

    if (timeoutDuration && !_isExpanded()) {
      pendingTimeout = setTimeout(() => {
        _onMessageTimeout();
      }, timeoutDuration);
    }
  }

  function _cancelTimeout() {
    clearTimeout(pendingTimeout);
    pendingTimeout = null;
  }

  function _addToQueue(message) {
    const insertIndex = _findInsertPosition(message);
    messageQueue.splice(insertIndex, 0, message);

    if (messageQueue[0] === message) {
      _showMessage(message);
    }
  }

  function _findInsertPosition(message) {
    for (let i = 0; i < messageQueue.length; i++) {
      const queuedMessage = messageQueue[i];
      if (
        message.priority > queuedMessage.priority ||
        (message.priority === queuedMessage.priority && message.timestamp < queuedMessage.timestamp)
      ) {
        return i;
      }
    }
    return messageQueue.length;
  }

  function _nextInQueue() {
    _cancelTimeout();
    messageQueue.shift();

    if (messageQueue.length === 0) {
      _toggleVisibility(false);
      return;
    }

    _showMessage(messageQueue[0]);
  }

  function dismiss(e) {
    _contract(e);
    _nextInQueue();
  }

  return {
    init,
    queueMessage,
    dismiss,
    _expand,
    _contract,
    _isExpanded,
    _onMessageTimeout,
    _isVisible,
  };
}

module.exports = StatusBanner();

const MapFunctions = require("../mapFunctions/mapFunctions");
